import { useMediaQuery as s } from "@ucl/react-library/useMediaQuery";
import { QUERIES as c } from "@ucl/shared-component-foundations/foundations";
const o = (i, r) => {
  const e = Object.entries(i).map(([t, n]) => `${n}` == "undefined" || `${n}` == "null" ? [
    t,
    r[t]
  ] : [
    t,
    n
  ]);
  return {
    ...r,
    ...Object.fromEntries(e)
  };
}, b = ({ mobile: i = {}, tablet: r = {}, ...e }) => {
  const t = s(c.mobile), n = s(c.tablet);
  return t ? o(i, o(r, e)) : n ? o(r, e) : e;
};
export {
  b as u
};
